import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import isEqual from 'fast-deep-equal';
import { PubSub } from './PubSub.js';
import { StoreOverloaded } from './StoreOverloaded.js';
var Store = {
    privilegesTool: {},
    launchDarklyTool: {},
    trackingTool: []
};
export var Debug = {
    getState: function getState(key) {
        if (__USE_DEBUG_BAR__ !== 'true') {
            StoreOverloaded.reset();
            return undefined;
        }
        var storeOverloadedByKey = StoreOverloaded.getByKey(key);
        return storeOverloadedByKey !== undefined ? storeOverloadedByKey : Store[key];
    },
    isOverloaded: function isOverloaded(key) {
        if (__USE_DEBUG_BAR__ !== 'true') {
            StoreOverloaded.reset();
            return false;
        }
        return StoreOverloaded.isKeyActive(Store, key);
    },
    resetState: function resetState(key) {
        if (__USE_DEBUG_BAR__ !== 'true') {
            StoreOverloaded.reset();
            return;
        }
        StoreOverloaded.resetByKey(key);
        PubSub.publish(key);
    },
    setState: function setState(key, setter) {
        var overloaded = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        if (__USE_DEBUG_BAR__ !== 'true') {
            StoreOverloaded.reset();
            return;
        }
        var after;
        var before;
        if (!overloaded) {
            before = Store;
            Store = _object_spread_props(_object_spread({}, Store), _define_property({}, key, setter(Store[key])));
            after = Store;
        } else {
            var storeOverloaded = StoreOverloaded.get();
            before = storeOverloaded;
            after = _object_spread_props(_object_spread({}, storeOverloaded), _define_property({}, key, setter(storeOverloaded[key] || Store[key])));
            StoreOverloaded.set(after);
        }
        if (!isEqual(before, after)) {
            PubSub.publish(key);
        }
    }
};

//# sourceMappingURL=Debug.js.map